export default __webpack_public_path__ + "static/media/047-seagull.20a3f750.png";